import { registerLocaleData } from '@angular/common';
import localeEnAu from '@angular/common/locales/en-AU';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

registerLocaleData(localeEnAu);
defineCustomElements(window);

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
